import React, { useState } from 'react';
import useScrollScale from '../hooks/useScrollScale';
import '../App.css';
import Header from './Header';
import zubayr from '../assets/profile_pics/zb.jpg';
import eesha from '../assets/profile_pics/es.jpg';
import david from '../assets/profile_pics/dvd.jpg';
import diyona from '../assets/profile_pics/dy.jpg';
import issy from '../assets/profile_pics/iz.jpg';
import hero_image from '../assets/hero_secondary.png';

function Portal() {
    const scale = useScrollScale();
    const [billingCycle, setBillingCycle] = useState('monthly');

    const toggleBillingCycle = (cycle) => {
        setBillingCycle(cycle);
    };

    // Sample candidate data
    const candidates = [
        {
            id: 1,
            initials: 'Zubayr Ghufoor',
            experience: 6,
            description: "Led Anduril's software platform development with deployment in active war zones.",
            expertise: ['Python', 'Pytorch', 'Docker', 'C++', 'SQL'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 94,
            image: zubayr
        },
        {
            id: 2,
            initials: 'Eesha Sondhi',
            experience: 22,
            description: "Led $600M bid for major broadband project; senior roles at Microsoft, Deloitte.",
            expertise: ['Strategic Planning', 'Project Management', 'Financial Analysis'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 87,
            image: eesha
        },
        {
            id: 5,
            initials: 'David Chen',
            experience: 10,
            description: "Developed AI and ML technologies at Apple, Intel, and MathWorks.",
            expertise: ['Python', 'C++', 'Objective-C'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 85,
            image: david
        },
        {
            id: 6,
            initials: 'Diyona Dsouza',
            experience: 17,
            description: "Led GE Healthcare as Chief Medical Officer, enhancing molecular imaging innovations.",
            expertise: ['Medical Writing', 'Regulatory Compliance', 'Strategic Planning'],
            commitment: 'Full-time',
            partTime: true,
            operationalFit: 83,
            image: diyona
        }
        // {
        //     id: 7,
        //     initials: 'Issobel Dipple',
        //     experience: 12,
        //     description: "Former product lead at Google, specialized in AI-driven user experiences.",
        //     expertise: ['Product Management', 'UX Design', 'AI Integration'],
        //     commitment: 'Part-time',
        //     partTime: true,
        //     operationalFit: 89,
        //     image: issy
        // }
    ];

    return (
        <div className="pricing-page">
            <Header />
            
            <div className="pricing-container">
                {/* <div className="pricing-header">
                    <div className="billing-toggle">
                        <button 
                            className={`toggle-button ${billingCycle === 'monthly' ? 'active' : ''}`}
                            onClick={() => toggleBillingCycle('monthly')}
                        >
                            COMPANY
                        </button>
                        <button 
                            className={`toggle-button ${billingCycle === 'yearly' ? 'active' : ''}`}
                            onClick={() => toggleBillingCycle('yearly')}
                        >
                            CANDIDATE
                        </button>
                    </div>
                </div> */}
                
                    <div className="company-dashboard">
                        <div className="candidate-hero-content" style={{marginBottom: '60px', marginTop: '30px'}}>
                            <h2>Find <span className="highlight">the best candidates</span> for you with Quokka.</h2>
                            <p style={{fontWeight: '200', marginTop: '-10px'}}>Recieve tailored candidates for your company's needs.</p>
                        </div>
                        <div className="pricing-features-section" style={{marginTop: '-10px'}}>
                            <div className="pricing-features-container" style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <div className="pricing-feature-card" style={{ backgroundColor: '#f8f8fc', borderColor: '#103A0E' }}>
                                    <div className="feature-card-inner">
                                        <div className="feature-title">One-time fee</div>
                                        <div className="feature-price">£1,000</div>
                                        <div className="feature-tag">
                                            <span className="checkmark" style={{ color: '#103A0E' }}>✓</span>
                                            Per Active Job Post
                                        </div>
                                    </div>
                                    <div className="feature-description">
                                        <h3>Simple</h3>
                                        <p>A predictable plan without unexpected costs later down the line.</p>
                                    </div>
                                </div>
                                
                                <div className="pricing-feature-card" style={{ backgroundColor: 'rgba(16, 58, 14, 0.05)', borderColor: '#103A0E' }}>
                                    <div className="feature-card-inner">
                                        <div className="feature-title">Save up to</div>
                                        <div className="feature-price">30%</div>
                                        <div className="feature-tag">
                                            <span className="checkmark" style={{ color: '#103A0E' }}>✓</span>
                                            Compared to competitors
                                        </div>
                                    </div>
                                    <div className="feature-description">
                                        <h3>Cost-effective</h3>
                                        <p>The best price you'll get compared to competitors and traditional agencies.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ai-features-section">
                            <h2 >What do we focus on?</h2>
                            <p style={{textAlign: 'center', paddingLeft: '10%', paddingRight: '10%'}}>At Quokka, we focus on operational fit which has been proven to be a large reason for unsuccessful hires. Our assessment is a simple first-stage filtering process to bring you the best candidates.</p>
                            <div className="ai-features-container">
                                <div className="ai-feature-card">
                                    <div className="ai-feature-icon">
                                        <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="1.5" fill="none">
                                            <path d="M12 8v4l3 3"></path>
                                            <circle cx="12" cy="12" r="10"></circle>
                                        </svg>
                                    </div>
                                    <h3>Flexibility</h3>
                                    <p>The importance of flexible work schedules and environments e.g. flexible hours, remote work options etc.</p>
                                </div>
                                
                                <div className="ai-feature-card">
                                    <div className="ai-feature-icon">
                                        <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="1.5" fill="none">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="9" cy="7" r="4"></circle>
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                        </svg>
                                    </div>
                                    <h3>Social Preferences</h3>
                                    <p>How individuals prefer to interact within the workplace, including their inclination toward teamwork, socialising with colleagues etc.</p>
                                </div>
                                
                                <div className="ai-feature-card">
                                    <div className="ai-feature-icon">
                                        <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="1.5" fill="none">
                                            <path d="M3 6l9 6 9-6"></path>
                                            <path d="M21 15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v6z"></path>
                                        </svg>
                                    </div>
                                    <h3>Workplace Values</h3>
                                    <p>The principles and atmosphere that define a workplace, including formal policies like dress codes etc.</p>
                                </div>

                                <div className="ai-feature-card">
                                    <div className="ai-feature-icon">
                                        <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="1.5" fill="none">
                                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                        </svg>
                                    </div>
                                    <h3>Work Style</h3>
                                    <p>Explores individual approaches to work, including preferences for structured versus unstructured tasks, the degree of autonomy desired etc.</p>
                                </div>

                                <div className="ai-feature-card">
                                    <div className="ai-feature-icon">
                                        <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" strokeWidth="1.5" fill="none">
                                            <path d="M12 20V10"></path>
                                            <path d="M18 20V4"></path>
                                            <path d="M6 20v-6"></path>
                                        </svg>
                                    </div>
                                    <h3>Career Growth</h3>
                                    <p>Addresses an individual's aspirations regarding professional development, advancement opportunities etc.</p>
                                </div>
                            </div>
                        </div>

                        <div className="search-container" style={{display: 'none'}}>
                            <div className="search-box">
                                <div className="avatar-placeholder">
                                    <img src={issy} alt="Avatar" className="avatar-image" />
                                </div>
                                <input 
                                    type="text" 
                                    className="search-input" 
                                    placeholder="Try searching 'Python developer with 4 years experience'"
                                />
                            </div>
                            <div className="filter-options">
                                <div className="filter-label">Can work</div>
                                <div className="filter-buttons">
                                    <button className="filter-button active">Full-time</button>
                                    <span className="filter-separator">or</span>
                                    <button className="filter-button">Part-time</button>
                                </div>
                                <button className="edit-filters-button">
                                    Edit filters
                                    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="candidates-list" style={{marginTop: '-20px'}}>
                            {candidates.map(candidate => (
                                <div className="candidate-card-horizontal" key={candidate.id}>
                                    <div className="candidate-info">
                                        <div className="candidate-header">
                                            <div className="candidate-avatar">
                                                <div className="avatar-circle">
                                                    <img src={candidate.image} alt="Avatar" className="avatar-image" />
                                                </div>
                                            </div>
                                            <div className="candidate-title">
                                                <h3>{candidate.initials}</h3>
                                                <button className="view-profile-button">View profile</button>
                                            </div>
                                        </div>
                                        <p className="candidate-description">{candidate.description}</p>
                                        <div className="candidate-details">
                                            <div className="expertise-section">
                                                <h4>Expert in</h4>
                                                <div className="expertise-tags">
                                                    {candidate.expertise.map((skill, index) => (
                                                        <span className="expertise-tag" key={index}>{skill}</span>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="commitment-section">
                                                <h4>Commitment</h4>
                                                <div className="commitment-options">
                                                    <span className="commitment-tag active">{candidate.commitment}</span>
                                                    {candidate.partTime && (
                                                        <span className="commitment-tag">Part-time</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {candidate.operationalFit && (
                                            <div className="operational-fit-badge" style={{
                                                '@media (max-width: 768px)': {
                                                    position: 'static',
                                                    marginTop: '20px',
                                                    alignSelf: 'flex-start'
                                                }
                                            }}>
                                                <span style={{fontSize: '2rem'}}>{candidate.operationalFit}%</span>
                                                <span className="fit-label">Operational Fit</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
            </div>

            <div className="get-started-section" style={{ backgroundColor: "#f0f0f4" }}>
                <div className="get-started-content" style={{ backgroundColor: "#f0f0f4" }}>
                    <div className="get-started-text">
                        <h2>Get started today</h2>
                        <p>Take Quokka for a spin. Try it out today.</p>
                        <a href="https://meetings.hubspot.com/david4497" className="get-started-button" target="_blank" rel="noopener noreferrer">
                            Schedule a demo<span className="arrow-icon">→</span>
                        </a>
                    </div>
                    <div className="get-started-image">
                        <img 
                            src={hero_image} 
                            alt="Quokka platform interface" 
                            className="hero-image-secondary"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Portal;
